import React from 'react';
import {
    Box,
    Button,
    Typography,
    Autocomplete,
    TextField,
    Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DatePicker } from "antd";
import { ROLES } from "../../constant/constant";
import dayjs from "dayjs";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Switch } from "@mui/material";

const FeedbackFilter = ({
    open,
    handleClose,
    currentRole,
    // State Values
    userId, setUserId,
    departmentId, setDepartmentId,
    roleName, setRoleName,
    values, setValues,
    statusValue, setStatusValue,
    timerValue, setTimerValue,
    sendStatusValue, setSendStatusValue,
    selectedDate, setSelectedDate,
    // Options
    userData,
    department,
    findDeptByUserId,
    SearchOption,
    TimerFilterOption,
    TimerSendStatusOption,
    // Handlers
    filterFunction,
    handleFilterApply, // Optional if different from filterFunction
    setFieldValue,
    setSelectedStatus,
    setSelectedTimerStatus,
    setSelectedSendStatus,
    userValue, setUserValue,
    // Follow Up
    supportTicket, setSupportTicket,
    filterKey, setFilterKey
}) => {
    const { RangePicker } = DatePicker;

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 600 }}>
                    Filters
                </Typography>
                <Button onClick={handleClose} sx={{ minWidth: 'auto', p: 0.5, color: '#999' }}>
                    ✕
                </Button>
            </Box>

            <Box sx={{ p: 2, overflowY: 'auto', flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>

                {/* SECTION: FOLLOW UP */}
                <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#555', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
                        Priority
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            p: 1.5,
                            border: '1px solid',
                            borderColor: supportTicket ? 'error.main' : 'divider',
                            borderRadius: 1,
                            bgcolor: supportTicket ? '#fff5f5' : 'transparent',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onClick={() => {
                            setSupportTicket(!supportTicket);
                            setFilterKey(!filterKey);
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <SupportAgentIcon color={supportTicket ? "error" : "action"} />
                            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: supportTicket ? 'error.main' : 'text.primary' }}>
                                Follow Up Required
                            </Typography>
                        </Box>
                        {/* <Switch 
                            size="small" 
                            checked={supportTicket} 
                            onChange={(e) => {
                                 // Handled by parent div click
                            }} 
                        /> */}
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                bgcolor: supportTicket ? 'error.main' : '#e0e0e0'
                            }}
                        />
                    </Box>
                </Box>

                <Divider />

                {/* SECTION: DEPARTMENT / ASSIGNEE — show for all admin-level roles */}
                {(currentRole === ROLES[0] || currentRole === ROLES[1] || currentRole === ROLES[2] || currentRole === ROLES[3]) && (
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, color: '#555', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
                            Assignment
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <Typography className="inputTitle" sx={{ fontSize: "12px", mb: 0.5 }}>
                                    Department
                                </Typography>
                                <Autocomplete
                                    options={department || []}
                                    getOptionLabel={(option) => option?.label || ""}
                                    value={
                                        department?.find(
                                            (dept) => dept.id === values?.assignedDepartmentId
                                        ) || null
                                    }
                                    onChange={(e, v) => {
                                        setFieldValue && setFieldValue("assignedDepartmentId", v?.id || null);
                                        setRoleName && setRoleName(v?.label || "");
                                        setFieldValue && setFieldValue("assignedTo", "");
                                        setDepartmentId(v?.id || null);
                                        // Switching department clears any selected assignee
                                        setUserId && setUserId(null);
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" placeholder="Select Department" />
                                    )}
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography className="inputTitle" sx={{ fontSize: "12px", mb: 0.5 }}>
                                    Assignee
                                </Typography>
                                <Autocomplete
                                    // Always show all users; department filter is optional refinement
                                    options={
                                        roleName && roleName !== "All"
                                            ? (findDeptByUserId && findDeptByUserId(roleName)) || userData || []
                                            : userData || []
                                    }
                                    getOptionLabel={(option) => option?.label || option?.name || ""}
                                    value={
                                        userData.find((user) => user._id === values?.assignedTo) || null
                                    }
                                    onChange={(e, v) => {
                                        setFieldValue && setFieldValue("assignedTo", v ? v._id : null);
                                        setUserId(v ? v._id : null);
                                    }}
                                    isOptionEqualToValue={(option, value) => option._id === value?._id}
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" placeholder="Select Assignee" />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                )}

                {(currentRole === ROLES[0] || currentRole === ROLES[1] || currentRole === ROLES[2] || currentRole === ROLES[3]) && <Divider />}

                {/* SECTION: TICKET STATUS */}
                <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, color: '#555', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
                        Ticket Status
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="inputTitle" sx={{ fontSize: "12px", mb: 0.5 }}>
                                Status
                            </Typography>
                            <Autocomplete
                                name="status"
                                placeholder="Select Status"
                                className="AutoComplete_InputBox"
                                value={
                                    SearchOption.find((option) => option.value === statusValue) ||
                                    null
                                }
                                options={SearchOption}
                                onChange={(e, newValue) => {
                                    setStatusValue(newValue ? newValue.value : null);
                                    if (newValue && newValue.value === null) {
                                        setSelectedStatus(null);
                                    } else {
                                        setSelectedStatus(newValue ? newValue.value : null);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        placeholder="Select Status"
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Typography className="inputTitle" sx={{ fontSize: "12px", mb: 0.5 }}>
                                Send Status
                            </Typography>
                            <Autocomplete
                                name="sendStatus"
                                placeholder="Select Send Status"
                                className="AutoComplete_InputBox"
                                value={
                                    TimerSendStatusOption.find(
                                        (option) => option.value === sendStatusValue
                                    ) || null
                                }
                                options={TimerSendStatusOption}
                                onChange={(e, newValue) => {
                                    setSendStatusValue(newValue ? newValue.value : null);
                                    if (newValue && newValue.value === null) {
                                        setSelectedSendStatus(null);
                                    } else {
                                        setSelectedSendStatus(newValue ? newValue.value : null);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        placeholder="Select Send Status"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Divider />

                {/* SECTION: TIMER */}
                <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, color: '#555', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
                        Timer
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="inputTitle" sx={{ fontSize: "12px", mb: 0.5 }}>
                                Timer
                            </Typography>
                            <Autocomplete
                                name="isExpired"
                                // disabled={!sendStatusValue}
                                placeholder="Select Timer Status"
                                className="AutoComplete_InputBox"
                                value={
                                    TimerFilterOption.find(
                                        (option) => option.value === timerValue
                                    ) || null
                                }
                                options={TimerFilterOption}
                                onChange={(e, newValue) => {
                                    setTimerValue(newValue ? newValue.value : null);
                                    if (newValue && newValue.value === null) {
                                        setSelectedTimerStatus(null);
                                    } else {
                                        setSelectedTimerStatus(newValue ? newValue.value : null);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        placeholder="Select Timer Status"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Divider />

                {/* SECTION: DATE RANGE */}
                <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, color: '#555', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
                        Date Range
                    </Typography>
                    <RangePicker
                        value={[
                            selectedDate?.startDate
                                ? dayjs(selectedDate?.startDate)
                                : dayjs().startOf("month"),
                            selectedDate?.endDate
                                ? dayjs(selectedDate?.endDate)
                                : dayjs().endOf("month"),
                        ]}
                        onChange={(e) =>
                            setSelectedDate({
                                ...selectedDate,
                                startDate: e?.[0] ? dayjs(e?.[0]).format("YYYY-MM-DD") : null,
                                endDate: e?.[1] ? dayjs(e?.[1]).format("YYYY-MM-DD") : null,
                            })
                        }
                        format={"DD/MM/YYYY"}
                        className="datePicker w-100"
                        style={{ width: '100%', height: '40px' }}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "20px",
                        mt: 2
                    }}
                >
                    <Button
                        className="cancelButton"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button className="addButton" onClick={filterFunction}>
                        Filter
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default FeedbackFilter;
